import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { majorClient } from '../client/majorClient';

type Options = {
};

const defaultOptions: Partial<Options> = {
};

export const useMajors = (params: Majors.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getMajors, params],
    queryFn: () => majorClient.getMajors(params),
  });

  return {
    ...rest,
    count: data?.count || 0,
    majors: data?.results || [],
  };
};
